import { useEffect, useState } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useSettingsController } from "../controller";
import { SettingsCard } from "./SettingsCard";
import { SettingsItem } from "./SettingsItem";

export const EntrataIntegration = () => {
  const { currentSettings, updateSettings } = useSettingsController();
  const [editMode, setEditMode] = useState(false);

  const [entrataDomain, setEntrataDomain] = useState("");
  const [entrataUsername, setEntrataUsername] = useState("");
  const [entrataPassword, setEntrataPassword] = useState("");

  const settings = currentSettings.entrata;

  useEffect(() => {
    setEntrataDomain(settings.entrataDomain || "");
    setEntrataUsername(settings.entrataUsername || "");
    setEntrataPassword(settings.entrataPassword || "");
  }, [
    settings.entrataDomain,
    settings.entrataUsername,
    settings.entrataPassword
  ]);

  const handleSaveSettings = () => {
    if (
      settings.entrataDomain !== entrataDomain ||
      settings.entrataUsername !== entrataUsername ||
      settings.entrataPassword !== entrataPassword
    )
      updateSettings({
        entrataDomain,
        entrataUsername,
        entrataPassword
      });
  };

  return (
    <SettingsCard title="Entrata integration" showButton={false}>
      <div className="border-b border-alpha-40 my-6" />
      <div className="flex mb-6 items-center justify-between">
        <h3 className="text-content-200 text-sm font-medium">
          Identity and access management
        </h3>
        {editMode ? (
          <Button
            variant={ButtonVariant.TEXT}
            size={ButtonSize.XS}
            onClick={() => {
              handleSaveSettings();
              setEditMode(false);
            }}
          >
            Save
          </Button>
        ) : (
          <Button
            variant={ButtonVariant.TEXT}
            size={ButtonSize.XS}
            onClick={() => setEditMode(true)}
          >
            Edit
          </Button>
        )}
      </div>
      <div className="mb-4">
        <SettingsItem
          title="Domain"
          value={entrataDomain}
          editMode={editMode}
          onChange={setEntrataDomain}
        />
      </div>
      <div className="mb-4">
        <SettingsItem
          title="Username"
          value={entrataUsername}
          editMode={editMode}
          onChange={setEntrataUsername}
        />
      </div>
      <div className="mb-4">
        <SettingsItem
          title="Password"
          value={entrataPassword}
          editMode={editMode}
          onChange={setEntrataPassword}
        />
      </div>
    </SettingsCard>
  );
};
